import { ScalingPolicyHpaFormFields } from './_constants';

import { DocsLinkKey } from '@cast/utils';

export const hpaSettingsConstants: Record<
  ScalingPolicyHpaFormFields,
  {
    title: string;
    description: string;
    docsLinkKey: DocsLinkKey;
  }
> = {
  takeOwnership: {
    title: 'HPA ownership',
    description:
      'Controls whether this policy takes over horizontal scaling for workloads that already have HPAs configured.',
    docsLinkKey: 'docs_woop_hpa', //todo(mike) update doc link after release
  },
  basicBehavior: {
    title: 'Pod Count',
    description:
      'Set the replica range within which the autoscaler can scale this workload.',
    docsLinkKey: 'docs_woop_hpa', //todo(mike) update doc link after release
  },
  metrics: {
    title: 'Triggers',
    description:
      'Set the average resource utilization at which the autoscaler adds or removes replicas.',
    docsLinkKey: 'docs_woop_hpa', //todo(mike) update doc link after release
  },
  autoscalerBehavior: {
    title: 'Autoscaling behavior',
    description:
      'Control how quickly the autoscaler adds or removes replicas, and how long it waits before acting on scaling signals.',
    docsLinkKey: 'docs_woop_hpa', //todo(mike) update doc link after release
  },
};
